import {
    FETCH_FORCE,
    FETCH_META,
    FETCH_PENDING,
    FETCH_REQUIRE,
    FETCH_UNAUTHORIZED,
    FETCHED_CLEAR,
    FETCHED_DATA,
    FETCHED_ERROR
} from './types'

// Require data to be fetched.
// Keep existing data if already fetched.
export function fetchRequire() {
    return {
        type: FETCH_REQUIRE
    }
}

// Force to fetch new data.
export function fetchForce(payload) {
    return {
        type: FETCH_FORCE,
        payload
    }
}

export function fetchMeta(payload) {
    return {
        type: FETCH_META,
        payload
    }
}

export function fetchPending() {
    return {
        type: FETCH_PENDING
    }
}

export function fetchedUnauthorized() {
    return {
        type: FETCH_UNAUTHORIZED
    }
}

export function fetchedData(data, response) {
    return {
        type: FETCHED_DATA,
        payload: {
            data,
            response
        }
    }
}

export function fetchedError(error, response) {
    return {
        type: FETCHED_ERROR,
        payload: {
            error,
            response
        }
    }
}

export function fetchClear(payload) {
    return {
        type: FETCHED_CLEAR,
        payload
    }
}
